import { useState } from 'react';
import checkIsUploadStable from '@anm/store/modules/uploads/helpers/checkIsStable';
import NotStableWarningModal from '@anm/components/NotStableWarningModal';

type HookProps = {
  projectId: string;
  onSuccess: () => void;
};

const useNotStableWarning = ({ projectId, onSuccess }: HookProps) => {
  const [isNotStable, setIsNotStable] = useState(false);

  const checkUpload = async () => {
    const isUploadStable = await checkIsUploadStable({ projectId });
    !isUploadStable ? setIsNotStable(true) : onSuccess();
  };

  const renderWarningModal = () =>
    isNotStable ? <NotStableWarningModal onProceed={onSuccess} onClose={() => setIsNotStable(false)} /> : null;

  return [checkUpload, renderWarningModal] as const;
};

export default useNotStableWarning;
